import {AnyAction, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IProductState} from 'modules/product-card/types';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootReducer} from 'core/redux/reducers';

export const productModuleName = 'product';

const initialState: IProductState = {
    currentProductData: null,
    currentProductSeo: null,
    productArticles: [],
    productCounter: {},
};

export const productSlice = createSlice({
    extraReducers: (builder) => {
        // eslint-disable-next-line complexity
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            const productState = payload[productModuleName] as IProductState | undefined;
            if (!productState) {
                return state;
            }

            return {
                ...state,
                ...productState,
                currentProductData: productState.currentProductData ?? state.currentProductData ?? null,
                currentProductSeo: productState.currentProductSeo ?? state.currentProductSeo ?? null,
                productCounter: productState.productCounter ?? state.productCounter ?? {},
            } as IProductState;
        });
    },
    initialState,
    name: productModuleName,
    reducers: {
        actionSetCurrentProduct(state: IProductState, {payload}: PayloadAction<IProductState['currentProductData']>) {
            state.currentProductData = payload;
        },

        actionSetCurrentProductSeo(state: IProductState, {payload}: PayloadAction<IProductState['currentProductSeo']>) {
            state.currentProductSeo = payload;
        },

        actionSetProductCounterCount(
            state: IProductState,
            {payload}: PayloadAction<IProductState['productCounter']['count']>,
        ) {
            state.productCounter.count = payload;
        },
    },
});

export const {
    actions: {actionSetCurrentProduct, actionSetCurrentProductSeo, actionSetProductCounterCount},
} = productSlice;

export const {reducer: productReducer} = productSlice;
